module.exports = __webpack_public_path__ + "img/boho_rio_gift_drink.2d0212e5.svg";